import { createSlice } from '@reduxjs/toolkit';

const liveVideoSlice = createSlice({
  name: 'liveVideo',
  initialState: {
    liveVideos: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    getLiveVideoRequest: (state) => {
      state.loading = true;
    },
    getLiveVideoSuccess: (state, action) => {
      state.loading = false;
      state.liveVideos = action.payload.data;
    },
    getLiveVideoFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addLiveVideoRequest: (state) => {
      state.loading = true;
    },
    addLiveVideoSuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    addLiveVideoFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteLiveVideoRequest: (state) => {
      state.loading = true;
    },
    deleteLiveVideoSuccess: (state) => {
      state.loading = false;
    },
    deleteLiveVideoFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetLiveVideoStatus: (state) => {
      state.success = false;
      state.error = null;
    }
  },
});

export const {
  getLiveVideoRequest,
  getLiveVideoSuccess,
  getLiveVideoFail,
  addLiveVideoRequest,
  addLiveVideoSuccess,
  addLiveVideoFail,
  deleteLiveVideoRequest,
  deleteLiveVideoSuccess,
  deleteLiveVideoFail,
  resetLiveVideoStatus
} = liveVideoSlice.actions;

export default liveVideoSlice.reducer;
